export default __webpack_public_path__ + "svg/Icon_240_peopleorgs.svg";